import i18nFactory from '@yandex-int/i18n';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { formatNumber } from '../../../service/FormatHelpers/FormatHelpers';
import { pluralizeWord } from '../../../service/Pluralize/Pluralize';
import { RecommendationCharacter, RecommendationType } from '../../../typings/recommendations';
import { Shape2Icon } from '../../Shape2/Shape2';
import { RecommendationCard, RecommendationCardView } from '../RecommendationCard';

import './LowShowsRecommendationCard.css';
import * as keyset from './LowShowsRecommendationCard.i18n';

const i18n = i18nFactory(keyset);

interface RecommendationsPopupViewProps {
    character: RecommendationCharacter;
    icon: Shape2Icon;
    view: RecommendationCardView.recommendationsPopup;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

interface NormalViewProps {
    character: RecommendationCharacter;
    icon: Shape2Icon;
    view: RecommendationCardView.normal;
    groupsNumber: number;
    groupsPageUrl: string;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

export type LowShowsRecommendationCardProps = RecommendationsPopupViewProps | NormalViewProps;

export class LowShowsRecommendationCard extends React.PureComponent<LowShowsRecommendationCardProps> {
    render() {
        const { view, character, icon, onShow } = this.props;

        return (
            <RecommendationCard
                type={RecommendationType.changeAdGroupWithLowStat}
                view={view}
                icon={icon}
                character={character}
                title={this.getTitle()}
                titleHint={this.getTitleHint()}
                buttons={this.getButtons()}
                isInProgress={false}
                onShow={onShow}
            >
                <p className={Bem.cls('low-shows-recommendations-card', 'text')}>
                    {i18n('check-phrases-and-groups-settings')}
                </p>
                <p className={Bem.cls('low-shows-recommendations-card', 'text')}>{i18n('check-show-conditions')}</p>
            </RecommendationCard>
        );
    }

    private getTitle = (): string => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return i18n('simple-title');
        }

        const itemsLength = this.props.groupsNumber;
        const formattedItemsLength = formatNumber(itemsLength);

        if (itemsLength === 1) {
            return i18n('one-group-title', {
                count: formattedItemsLength
            });
        }

        return pluralizeWord(
            [
                i18n('twenty-one-group-title', {
                    count: formattedItemsLength
                }),
                i18n('some-group-title', {
                    count: formattedItemsLength
                }),
                i18n('many-group-title', { count: formattedItemsLength })
            ],
            this.props.groupsNumber
        );
    };

    private getTitleHint = (): string => {
        const { view } = this.props;

        switch (view) {
            case RecommendationCardView.normal:
                return i18n('several-group-title-hint');

            case RecommendationCardView.recommendationsPopup:
                return i18n('one-group-title-hint');

            default:
                throw Error(`Не определена подпись для заголовка рекомендации вида ${view}`);
        }
    };

    private getButtons = () => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return undefined;
        }

        const { groupsPageUrl, groupsNumber } = this.props;
        const formattedItemsLength = formatNumber(groupsNumber);

        const buttonText = pluralizeWord(
            [
                i18n('show-one-group-button', {
                    count: formattedItemsLength
                }),
                i18n('show-some-group-button', {
                    count: formattedItemsLength
                }),
                i18n('show-many-group-button', {
                    count: formattedItemsLength
                })
            ],
            groupsNumber
        );

        return [<Button key={1} theme={'action'} size={'n'} text={buttonText} type={'link'} url={groupsPageUrl} />];
    };
}
